module.exports = require('react/lib/ReactTransitionGroup');


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/react-addons-transition-group/index.js
// module id = 722
// module chunks = 0